// Equivalent to jQuery $(document).ready()
function ready( onReady ) {
	if ( document.readyState !== 'loading' ){
		onReady();
	} else if ( document.addEventListener ) {
		document.addEventListener( 'DOMContentLoaded', onReady );
	} else {
		document.attachEvent( 'onreadystatechange', function() {
			if ( document.readyState !== 'loading' ) {
				onReady();
			}
		});
	}
}

// Slideshows
import Glide from '@glidejs/glide'
function slidersInit() {
	if( document.querySelector( '.glide' )) {
		const slideshow = new Glide('.glide', {
			type: 'carousel',
            hoverpause: false,
            autoplay: 5000
		});
		slideshow.mount();
	}
}

// Nav dropdowns
import expand_menu from './nav.js';

// Compressing header on scroll
import compress_header from './compress-header.js';

// Visibility view switcher
import viewSwitcher from './highviz.js';

// Switcher event listener
import switcher from './switcher.js';

// Sharing copy URL
import copyURLforSharing from './click-to-copy.js';

// When the page is ready, add the event listeners to the select dropdowns
function whenReady() {

	// expander
	switcher("license-more", "license", "closed", true);

	// navigation menu
	expand_menu( 'mainnav-toggle', 'header')

	// compressing header
	compress_header();

    // High contrast style switcher
    viewSwitcher('view-switcher', 'body', 'view-simple');

	// apply glidejs to sliders
	slidersInit();

    // Set up sharing copy
    copyURLforSharing();
}
ready( whenReady );
